import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';

import React from 'react';
import { ResponsiveWidth } from 'ui-components/components/responsive-layout';
import { Card } from 'ui-components/components/card';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { Pill } from 'ui-components/components/pill';
import { AuthGatedSection } from './auth-gated-section';
import { messages } from './messages';
import style from './security.module.less';
import { FormattedMessage } from 'react-intl';

export const SecuritySection = () => {
  return (
    <FlexColumn responsiveWidth={ResponsiveWidth.Cols9}>
      <Text textType={TextType.H3} value={messages.securitySubHeader} />
      <Card>
        <FlexRow gap={Gap.Space8}>
          <Text textType={TextType.H4} value={messages.multiFactorAuthenticationTitle} />
          <Pill
            className={style['mfa-enabled-pill']}
            icon={<FontAwesomeIcon className={style['green-status-dot']} icon={faCircle} />}
            label={<FormattedMessage {...messages.mfaEnabledStatus} />}
            theme='enabled'
          />
        </FlexRow>
        <Text textType={TextType.Paragraph} value={messages.multiFactorAuthenticationText} />
        <AuthGatedSection />
      </Card>
    </FlexColumn>
  );
};
